'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPage from '@campaign-manager/app/ui/react/features/error/ErrorPage';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Report error to Sentry
    Sentry.captureException(error, {
      tags: { errorBoundary: 'global-error' },
      extra: { digest: error.digest },
    });

    // Also log to console for debugging
    console.error('Global error:', error);
  }, [error]);

  return (
    <html
      lang="en"
      style={{ backgroundColor: '#f7f7f7' }}
    >
      <head>
        <link
          rel="preconnect"
          href="https://p.typekit.net"
        />
        <link
          rel="preconnect"
          href="https://use.typekit.net"
        />
        <link
          href="https://use.typekit.net/fns3jzm.css"
          rel="stylesheet"
        />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link
          rel="manifest"
          href="/site.webmanifest"
        />
        <link
          rel="mask-icon"
          href="/safari-pinned-tab.svg"
          color="#5bbad5"
        />
        <meta
          name="msapplication-TileColor"
          content="#da532c"
        />
        <meta
          name="theme-color"
          content="#ffffff"
        />
      </head>
      <body>
        <ErrorPage
          error={error}
          showReloadButton
        />

        <script
          defer
          async
          src="https://upload-widget.cloudinary.com/global/all.js"
        />
      </body>
    </html>
  );
}
